import { render, staticRenderFns } from "./iotmenu.vue?vue&type=template&id=22df73cd"
import script from "./iotmenu.vue?vue&type=script&lang=js"
export * from "./iotmenu.vue?vue&type=script&lang=js"
import style0 from "./iotmenu.vue?vue&type=style&index=0&id=22df73cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports